import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../../const";
import { fetchKids } from "../../../Kids-list.ducks";
import _ from 'lodash';
import { Service } from "../../../../../service/service"
import { unAuthorized } from '../../../../../auth/Auth.ducks'
// Arrivée actions

export const POST_ARRIVE_PENDING = "POST_ARRIVE_PENDING";
export const POST_ARRIVE_REJECTED = "POST_ARRIVE_REJECTED";
export const POST_ARRIVE_FULFILLED = "POST_ARRIVE_FULFILLED";

export const GET_ARRIVE_PENDING = "GET_ARRIVE_PENDING";
export const GET_ARRIVE_REJECTED = "GET_ARRIVE_REJECTED";
export const GET_ARRIVE_FULFILLED = "GET_ARRIVE_FULFILLED";


export const PUT_ARRIVE_PENDING = "PUT_ARRIVE_PENDING";
export const PUT_ARRIVE_REJECTED = "PUT_ARRIVE_REJECTED";
export const PUT_ARRIVE_FULFILLED = "PUT_ARRIVE_FULFILLED";

export const DELETE_ARRIVE_PENDING = "DELETE_ARRIVE_PENDING";
export const DELETE_ARRIVE_REJECTED = "DELETE_ARRIVE_REJECTED";
export const DELETE_ARRIVE_FULFILLED = "DELETE_ARRIVE_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_ARRIVE_PENDING:
    case GET_ARRIVE_PENDING:
    case PUT_ARRIVE_PENDING:
      return true;
    case POST_ARRIVE_REJECTED:
    case POST_ARRIVE_FULFILLED:
    case GET_ARRIVE_REJECTED:
    case GET_ARRIVE_FULFILLED:
    case PUT_ARRIVE_REJECTED:
    case PUT_ARRIVE_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_ARRIVE_PENDING:
    case POST_ARRIVE_FULFILLED:
    case GET_ARRIVE_PENDING:
    case GET_ARRIVE_FULFILLED:
    case PUT_ARRIVE_PENDING:
    case PUT_ARRIVE_FULFILLED:
      return null;
    case POST_ARRIVE_REJECTED:
    case GET_ARRIVE_REJECTED:
    case PUT_ARRIVE_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_ARRIVE_FULFILLED:
    case GET_ARRIVE_FULFILLED:
    case PUT_ARRIVE_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;

    case POST_ARRIVE_PENDING:
    case GET_ARRIVE_PENDING:
    case PUT_ARRIVE_PENDING:
      return null;
    case POST_ARRIVE_REJECTED:
    case GET_ARRIVE_REJECTED:
    case PUT_ARRIVE_REJECTED:
      return null;

    default:
      return state;
  }
};

// Arrivée reducer

export default combineReducers({ loading, error, data });

export const postArriveSimple = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/${id}/arrivees`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_ARRIVE_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
       dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_ARRIVE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const getArriveEvent = (tok, idEvent,isUpdate,isView) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/enfant/creche/arrivees/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_ARRIVE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_ARRIVE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const updateArriveEvent = (tok, idEvent, data) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/arrivees/${idEvent}`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: PUT_ARRIVE_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: PUT_ARRIVE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const deleteArriveEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.deleteOne(`${API}api/enfant/creche/arrivees/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: DELETE_ARRIVE_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: DELETE_ARRIVE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}